/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable max-len */

const deprecationNotice = `
===============================================
DEPRECATION NOTICE: CLI VERSION 0.39.0
===============================================

The CLI version 0.39.0 is officially deprecated and will no longer receive active support for Datastore.

While existing installations will continue to function, no new installations or updates will be supported using this version.

🚀 Main Benefit of the Next CLI Version:
   - Multiple DXP tools (Data Store, Component Service, Job Runner) are now integrated into a unified CLI, enhancing efficiency and centralising control.

🛠️  Recommended Actions:
   1. Upgrade to the latest CLI version to access the integrated DXP tools:
   2. Update your workflows and scripts to accommodate changes introduced in the new version.
   3. Refer to the updated documentation from Squiz help center.

ℹ️  For more information, visit https://docs.squiz.net/datastore/latest/using/datastore-cli.html
`;

console.log(deprecationNotice);
